/* Stitchi Studio · cadeaubon.js
   Live voorbeeld, controle en "In winkelwagen" voor sections/main-cadeaubon.liquid (overgenomen uit de preview cadeaubon.html).
   Eigen regel-eigenschappen: Voor, Van, Bericht, Ontwerp, Gelegenheid (die leest templates/gift_card.liquid).
   Shopify's ontvangersvelden (Recipient email/name, Message, Send on) gaan alleen mee als er een e-mailadres is;
   zonder adres krijgt de koper de bon zelf. */
(function () {
  'use strict';
  var f = document.getElementById('bonform');
  if (!f) return;
  var $ = function (s) { return document.getElementById(s); };
  var bon = $('bon'), melding = $('bon-melding');
  var STANDAARD = $('b-bericht').textContent;

  function bedragInput() { return f.querySelector('input[name="id"]:checked'); }
  function ontwerpInput() { return f.querySelector('input[name="properties[Ontwerp]"]:checked'); }
  function gelegenheidInput() { return f.querySelector('input[name="properties[Gelegenheid]"]:checked'); }
  function eersteGelegenheid() { return f.querySelector('input[name="properties[Gelegenheid]"]'); }
  function naarOntvanger() { var r = f.querySelector('input[name="bezorging"]:checked'); return !!r && r.value === 'ontvanger'; }

  /* "verstuur op": vandaag t/m 90 dagen vooruit (Shopify plant cadeaubonnen maximaal 90 dagen vooruit) */
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  var VANDAAG = new Date(), TOT = new Date(); TOT.setDate(TOT.getDate() + 90);
  function datumOk(v) { return /^\d{4}-\d{2}-\d{2}$/.test(v) && v >= iso(VANDAAG) && v <= iso(TOT); }
  $('datum').min = iso(VANDAAG); $('datum').max = iso(TOT);

  /* galerij: live bon of de geprinte bon */
  function toonDia(naar) {
    document.querySelectorAll('.p-bon .cb-dia').forEach(function (d) { d.classList.toggle('is-actief', d.id === 'dia-' + naar); });
    document.querySelectorAll('.p-bon .cb-duim').forEach(function (k) { var aan = k.getAttribute('data-naar') === naar; k.classList.toggle('is-actief', aan); k.setAttribute('aria-selected', aan); });
    var t = $('podium-tekst'); if (t) t.textContent = naar === 'bon' ? 'Live voorbeeld · zo ziet de ontvanger de bon' : 'Zo ziet de bon eruit als je hem uitprint';
  }
  document.querySelectorAll('.p-bon .cb-duim').forEach(function (k) { k.addEventListener('click', function () { toonDia(k.getAttribute('data-naar')); }); });

  function update() {
    var b = bedragInput(), o = ontwerpInput(), g = gelegenheidInput();
    var klas = o ? o.getAttribute('data-klas') : 'goud';
    bon.className = 'bb-bon ' + klas;
    if ($('duim-bon')) $('duim-bon').className = 'cb-duim-bon ' + klas;
    $('b-soort').textContent = g && g !== eersteGelegenheid() ? 'Cadeaubon · ' + g.getAttribute('data-tekst') : 'Cadeaubon';
    $('cb-ontvanger').hidden = !naarOntvanger();
    var label = b ? b.getAttribute('data-label') : '€ …';
    $('b-bedrag').textContent = label;
    var naam = $('naam').value.trim(), van = $('van').value.trim(), ber = $('bericht').value.trim();
    $('b-voor').textContent = 'Voor ' + (naam || 'jou');
    $('b-bericht').textContent = ber || STANDAARD;
    $('b-van').textContent = van ? 'Van ' + van : '';
    $('teken').textContent = $('bericht').value.length + '/160';
    $('cb-prijs').textContent = b ? b.getAttribute('data-prijs') : '–';
    $('knop-prijs').textContent = label;
    $('cb-bedrag').textContent = b ? label : 'kies bedrag';
    if ($('bedrag-hint')) $('bedrag-hint').textContent = b ? b.getAttribute('data-hint') || '' : '';
    if (naam) $('v-naam').classList.remove('ongeldig');
  }
  f.addEventListener('input', function () { toonDia('bon'); update(); });
  f.addEventListener('change', function (e) { toonDia('bon'); update(); if (e.target.name === 'bezorging' && naarOntvanger()) $('omail').focus(); });

  /* de vaste balk valt nooit over een veld met het toetsenbord open */
  var balk = $('cb-balk');
  f.addEventListener('focusin', function (e) { if (/^(INPUT|TEXTAREA)$/.test(e.target.tagName) && e.target.type !== 'radio') balk.classList.add('typen'); });
  f.addEventListener('focusout', function () { balk.classList.remove('typen'); });
  /* en is weg zolang de echte knop in beeld is */
  var knop = f.querySelector('.cb-form-knop');
  if ('IntersectionObserver' in window && knop) new IntersectionObserver(function (en) { balk.classList.toggle('verborgen', en[0].isIntersecting); }).observe(knop);

  function markeer(veld, input, fout) {
    $(veld).classList.toggle('ongeldig', fout);
    if (fout) $(input).setAttribute('aria-invalid', 'true'); else $(input).removeAttribute('aria-invalid');
    return fout;
  }
  function meld(tekst, fout) {
    melding.textContent = tekst;
    melding.classList.toggle('fout', !!fout);
    melding.hidden = !tekst;
  }

  /* Ella's zijwinkelwagen verversen en openen zoals theme.js updateSidebarCart doet (halo is daar niet globaal) */
  function openWinkelwagen() {
    var na = window.after_add_to_cart && window.after_add_to_cart.type;
    var root = (window.routes && window.routes.root) || '';
    var cartUrl = (window.routes && window.routes.cart) || '/cart';
    var lade = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (na === 'cart' || !lade) { window.location.href = cartUrl; return; }
    var lijst = document.querySelector('#halo-cart-sidebar [data-mini-cart-items]');
    var tekst = function (r) { if (!r.ok) throw new Error(r.status); return r.text(); };
    Promise.all([
      fetch(root + '/cart?view=ajax_side_cart', { cache: 'no-store' }).then(tekst),
      lijst ? fetch(root + '/cart?view=ajax_mini_cart', { cache: 'no-store' }).then(tekst) : null,
      fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      lade.innerHTML = res[0];
      if (lijst && res[1] != null) lijst.innerHTML = res[1];
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = res[2].item_count; });
      document.body.classList.add('cart-sidebar-show');
    }).catch(function () { window.location.href = cartUrl; });
  }

  f.addEventListener('submit', function (e) {
    e.preventDefault();
    meld('');
    var b = bedragInput(), naam = $('naam').value.trim(), eerste = null;
    var ontv = naarOntvanger(), omail = ontv ? $('omail').value.trim() : '', datum = ontv ? $('datum').value : '';
    if (!b) eerste = f.querySelector('input[name="id"]');
    if (markeer('v-naam', 'naam', !naam)) eerste = eerste || $('naam');
    if (markeer('v-omail', 'omail', ontv && !/^[^\s@]+@(?![^\s@]*\.\.)[^\s@]+\.[^\s@]{2,}$/.test(omail))) eerste = eerste || $('omail');
    if (markeer('v-datum', 'datum', !!datum && !datumOk(datum))) eerste = eerste || $('datum');
    if (eerste) { eerste.focus(); meld('Controleer de gemarkeerde velden.', true); return; }

    var ber = $('bericht').value.trim(), van = $('van').value.trim();
    var props = { Voor: naam, Ontwerp: ontwerpInput().value }, g = gelegenheidInput();
    if (g && g !== eersteGelegenheid()) props.Gelegenheid = g.getAttribute('data-tekst');
    if (van) props.Van = van;
    if (ber) props.Bericht = ber;
    if (omail) {
      props['Recipient email'] = omail;
      props['Recipient name'] = naam;
      if (ber) props.Message = ber;
      if (datum) props['Send on'] = datum;
      props.__shopify_send_gift_card_to_recipient = 'on';
    }

    var knoppen = document.querySelectorAll('.p-bon button[type=submit]');
    knoppen.forEach(function (k) { k.classList.add('laden'); k.disabled = true; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.value, quantity: 1, properties: props }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Toevoegen lukte niet'); return j; });
    }).then(function () {
      meld('Cadeaubon voor ' + naam + ' toegevoegd.');
      openWinkelwagen();
    }).catch(function (err) {
      meld(err.message + '. Probeer het nog eens.', true);
    }).then(function () {
      knoppen.forEach(function (k) { k.classList.remove('laden'); k.disabled = false; });
    });
  });

  /* voorinvullen via ?bedrag=75 */
  var q = parseFloat(new URLSearchParams(window.location.search).get('bedrag'));
  if (q) f.querySelectorAll('input[name="id"]').forEach(function (r) { if (+r.getAttribute('data-bedrag') === q && !r.disabled) r.checked = true; });
  update();
})();
